import React, { useEffect,useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { isEmpty, map } from "lodash";
import axios from "../../axios"
import numeral from "numeral";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { makeStyles } from '@material-ui/core/styles';
import  Spinner  from 'react-spinkit'
import Backdrop from '@material-ui/core/Backdrop';
//Import Image
import logo from "../../assets/images/logo-dark.png";
import PropTypes from "prop-types";
import { getInvoiceDetail } from "../../store/invoices/actions";
import { Dialog, DialogTitle } from "@material-ui/core";
import { connect } from "react-redux";
const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  
  
  
  }));
const InvoiceDetail = props => {
  const {
    invoiceDetail,
    match: { params },
    onGetInvoiceDetail,
  } = props;

  useEffect(() => {
    if (params && params.id) {
      onGetInvoiceDetail(params.id);
    } else {
      onGetInvoiceDetail(1); //remove this after full integration
    }
    Getallsuppliervalue()
  }, [params, onGetInvoiceDetail]);

  //Print the Invoice
  const printInvoice = () => {
    window.print();
  };
const Getallsuppliervalue = async() => {
    const get= await axios.instance.get(`/Getonesalesorderdetail/${props.match.params.id}`,{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      
    //////////////console.log(res.data)
      setpurchasegetone(res.data)
      var getoneprodctsofpurchse = res.data
      
      // //////console.log('',getoneprodctsofpurchse)
        localStorage.setItem('Salescart',JSON.stringify(getoneprodctsofpurchse))
        let qtytotal = []
      
        for(const data of res.data){
        qtytotal.push(parseFloat(data.Order_Qty))
        }
        var qtyvalue = 0 
        for (let i = 0; i < qtytotal.length; i++) {
          qtyvalue += qtytotal[i];
        }
        settotalqty(qtyvalue)
        localStorage.setItem('TotalQty1',qtyvalue)
        
        let taxtotal = []
        for(const data of res.data) {
        taxtotal.push(parseFloat(data.GSTPer))  
        }
        var taxvalue = 0
        for(let i =0; i< taxtotal.length; i++) {
        taxvalue += taxtotal[i]
        }
        localStorage.setItem('taxvalue1',taxvalue)
        //AsyncStorage.setItem('Toataltax', taxvalue.toString())
        let  totalnetamount = []
        for(const data of res.data) {
          totalnetamount.push(parseFloat(data.Rate * data.Order_Qty))
        }
        var totalnetcount = 0
        for(let i =0; i< totalnetamount.length; i++) {
          totalnetcount += totalnetamount[i]
        }
        //settotalamt(totalnetcount)
        //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
        //localStorage.setItem('Totalsumamounts1',totalnetcount)
        
        
        localStorage.setItem('Totalsumamounts1',totalnetcount)
       
        let  totalsalesrate = []
        for(const data of res.data) {
          totalsalesrate.push(parseFloat(((((data.Rate)/(100 + data.GSTPer)*100))* parseFloat(data.Order_Qty))))
        }
        var totalsalescount = 0
        for(let i =0; i< totalsalesrate.length; i++) {
          totalsalescount += totalsalesrate[i]
        }
        //settotalamt(totalnetcount)
        //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
        //localStorage.setItem('Totalsumamounts1',totalnetcount)
        
        
        localStorage.setItem('totalsalesrate',totalsalescount)
       
    
    
    
    
    
    
    
    
    
        let totalIgstamt = []
        for(const data of res.data) {
        totalIgstamt.push(parseFloat((data.Rate * data.Order_Qty) * data.GSTPer/100))
        ////////////console.log('igst', data.IGSTPer)
        }
        var  totalIgstvalu = 0
        for(let i=0; i< totalIgstamt.length; i++) {
        totalIgstvalu +=totalIgstamt[i]
        }
        localStorage.setItem('Totaligstvalue1',totalIgstvalu)
      
    
    
        let totalsalesigstvaleu = []
        for(const data of  res.data) {
          totalsalesigstvaleu.push(parseFloat((totalsalescount * data.GSTPer)/100))
        ////////////console.log('igst', data.IGSTPer)
        ////////console.log('test', data.GSTPer)
        }
        var  totalsalesamt = 0
        for(let i=0; i< totalsalesigstvaleu.length; i++) {
          totalsalesamt +=totalsalesigstvaleu[i]
        }
        localStorage.setItem('totalsalesgstamt',totalsalesamt)
      
    
        //////////console.log(totalIgstvalu)
        //settotaltax(totalcgstvalu +totalcgstvalu)
        setTOtaligstamt(totalIgstvalu)
    })
    }
    const [purchasegetone, setpurchasegetone] = useState([])
    const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
    const [allcartproducts, setallcartproducts] = useState([])
    const [purchseid, setpurchseid] = useState('')
    const [Purchasesavess, setPurchasesavess] = useState(false)

    const [allproductslists, setallproductslists] = useState([])
    const [qtyval, setqtyval] = useState('1')
    const classes = useStyles();
    const [pricevalue, setpricevalue] = useState('')
    const [modal, setModal] = useState(false)
    const [indexalueofupdate, setindexalueofupdate] = useState('')
    const [Productonecollect, setProductonecollect] = useState([])
    const [sgstper, setsgstper] = useState('')
    const [salesrate, setsalesrate] = useState('')
    const [proid, setproid] = useState('')
    const [vatper, setvatper] = useState('')
    const [uomdesc, setuomdesc] = useState('')
    const [cgstper, setcgstper] = useState('')
    const [taxid, settaxid] = useState('')
    const [purchaseqtys, setpurchaseqtys] = useState('1')
    const [totalqty, settotalqty] = useState('')
    const [TOtaligstamt, setTOtaligstamt] = useState('')
    const [deleteModal, setDeleteModal] = useState(false)
    const [deletid, setdeletid] = useState('')
    const [delteprods, setdelteprods] = useState(false)
    const [updatenetamt, setupdatenetamt] = useState('')
    
    const [productnames, setproductnames] = useState('')
    const [provalue, setprovalue] = useState([])
    const [uomid, setuomid] = useState('')
    const [conqty, setconqty] = useState('')
    const [discountper, setdiscountper] = useState('')
    const [gstper, setgstper] = useState('')
    const [sgstid, setsgstid] = useState('')
    const [dailoa1, setdailoa1] = useState(false)
    const [cgstpercentages, setcgstpercentages] = useState('')
    const [igstper, setigstper] = useState('')
    const [produpdata, setprodupdata] = useState(false)
    var imageDefault = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAANlBMVEX///+/v7+8vLzKysr8/Pzg4ODFxcXb29vT09Pj4+P4+PjBwcH6+vry8vLY2NjIyMjs7Ozo6Oia8u11AAAEdUlEQVR4nO2d65bqIAxGp/Smrb34/i971KqlEC7FGuJZ3/7dKewJBgK4/PsDAAAAAAAAAAAAAAAA4KUam5+i3m94UsUPoVoYwlA6MIShfGAIQ/nAEIbyOcBQSeNww9NZGOXBhuq8+w1fxugfDG1gmB0YBoFhdmAYBIbZgWEQGGYHhkFgmB0YBoFhdmAYBIbZyWB4qVI6mgyv4WUeH7u007lL7vFeWA3n8rUFrZqWK5KchnWvPapOTGFkNDQPOJrhk45Hw2d4Ns+oVPlRz2NhMxyawkTtv2OWAJvhSBwzfjBO2+g/5TLs7BDeSF4eDP0Y+yiX4UydFKtT4pRxa3SKTcVchtQgLYrobhq0Kj7+XIb0aX+fZtipHfH/ScPlZZG5Jq9hk2RYP96lTnFPcxnWpGF52d2eNrPGPc5lOJC5NDrl65Sv1fs16nEuw8v20sdCP+9uTh8NZVSuYVvTnKlBmjAdaqu/uH8Qm2FVWuNUJYSwOu3tLV9tcelNw5SF9yZjRaVixvpwbrZRTKnyuyKysRXOGn/QBqpK25QzptVm9598eyfqXDaPnah+GlNmwr/aGOcqYl3DvJtYzXU7jvU1bbVmVdExE+pP7Qjb6TiiOBFmOPuyD7XyC+djWYadGt2KxE5PzMpWluHtXc6KQZ/rNYK5RpThfWXnrGzp6iRcQ0ky7KbHK+iBup3rtQZD6wZJhq+9HDIsri89BBsUZPguIal0Y871K6ECRY6hXkFaimQeXQjVUHIMNwWkuVax5/q1xcC6Rozh0G+7vYmidaqzCaJ/whBjaEZJr608Y7QIHvBIMbR3/dfB55jr3/hrKCGGxMHN+vmi53rtSW+uEWLYUj1/dsY1169tetc1MgwHaw9HU3TN9Svec0huw4os6CZHcO7dcc/163O+XMNteC0JRfdk0Aby6BNfDcW9i1EquzedI4R36vAYLfy5htnwtnBRvaHo/SZxjN8Nz7UO5ltf97WnMgbqHCfhRbmHKa/hdXl2qxjzQQsaunMNr+FzUlD62W8bORD9TM4gshpe3xVg+Z7BonJlmN55mMhpWGkV4GughtacsbgvLnAa6hXga6B666I9OGsoRsPtMbCa7l2q6OVaAs6uMxpejXDdd+SPSTMP+vyGdri6+bAQui8u8BmaIbwxUdcXkg0dNRTjOf6BNiSOGirrXYxjcXQ+632ag6EPE7kMiU/h4dA1FJfhgUnTzZTRkCOEt8apYcpj+P1E6u4+j+H3E+kCdUmKxZAjkS4QrbMY8nwKC7qGYjFkSaQL9rqGw5AthORhIoMhUyJ9ksPwsDI+Brv97xtWY8mJNUwZYtixYu0qyjhd+yYwDALD7MAwCAyzA8MgMMwODIPAMDtHGxZ1JYvjDRvWajCC7SYRfhsBhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvJJM/wpEgyv9U+R8iNaAAAAAAAAAAAAAAAAAP4r/gEYCYE2Xwz6DQAAAABJRU5ErkJggg=='
    const [prodimage, setprodimage] = useState('')
    const [open1, setopen1] = useState(false)
    const [purchsdtlid, setpurchsdtlid] = useState('')
    const [igstid, setigstid] = useState('')
    const [billraised, setbillraised] = useState('')
    const [qtyerror, setqtyerror] = useState(false)
    const [purchaseupdatesmessage, setpurchaseupdatesmessage] = useState(false)
    const viewpage = async() =>{
        setdailoa1(true)
        
        // localStorage.setItem('purchseeditid',id)
         const PrintInvoice = await axios.instance.get(`/Salesprint/${props.match.params.id}`).then(async() => {
         const downloadprogress =  await axios.instance.get('/GetSalesOrder',{ responseType: 'blob'}).then((res) => {
           const pdfBlob = new Blob([res.data] ,{type: 'application/pdf'})
          
       // localStorage.setItem('Purchaseorderedit',false)
        //localStorage.setItem('purchaseviewscreen','Y')
        //toggle()
        //history.push(axios.baseURL+`Getpurchaseorder`)
      
       setopen1(true)
    
       setTimeout(() => {
        setdailoa1(false)
       }, 2000);
    })
    })
          }
          const Closepopup1 = () => {
            setopen1(false)
            setdailoa1(false)
                 }  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Sales Order" breadcrumbItem="Sales Order Detail" />
       
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <div className="invoice-title">
                    
                      {/* <div className="mb-4">
                        <img src={logo} alt="logo" height="20" />
                      </div> */}
                   
                    </div>
                    <hr className="my-4" />
                    {/* <Row>
                      <Col sm="6">
                        <div className="text-muted">
                          <h5 className="font-size-16 mb-3">Billed To:</h5>
                          <h5 className="font-size-15 mb-2"></h5>
                          <p className="mb-1">{invoiceDetail.billingAddress}</p>
                          <p className="mb-1">{invoiceDetail.billingEmail}</p>
                          <p>{invoiceDetail.billingPhoneno}</p>
                        </div>
                      </Col>
                      <Col sm="6">
                        <div className="text-muted text-sm-end">
                          <div>
                            <h5 className="font-size-16 mb-1">Invoice No:</h5>
                            <p></p>
                          </div>
                          <div className="mt-4">
                            <h5 className="font-size-16 mb-1">Invoice Date:</h5>
                            <p></p>
                          </div>
                          <div className="mt-4">
                            <h5 className="font-size-16 mb-1">Order No:</h5>
                            <p>#</p>
                          </div>
                        </div>
                      </Col>
                    </Row> */}
                    <div className="py-2">
                      <h5 className="font-size-15">Order summary</h5>
                      <div className="table-responsive">
                        <Table className="table-nowrap table-centered mb-0">
                          <thead>
                            <tr>
                            <th> S.No</th>
                            <th >Product Description</th>
                          <th >Image</th>
                          <th >Net Rate</th>
                          <th >Sales Rate</th>
                          <th >Qty</th>
                     
                          <th >Gst %</th>
                          <th >Gst Amount</th>
                          <th >Total</th>
                            </tr>
                          </thead>
                          <tbody>
                           
                    
                           {purchasegetone.map((data,index)=>(
                                <tr key={index}>
                                  <td>{index+1}</td>
                                 
                                  <td style={{fontSize:"13px"}} > {data.Product_Details_Description}</td>
                          <td style={{fontSize:"13px"}}> <img src={`${data.Imagepath}`} height="50px" width="50px" /></td>
                    
                          <td style={{fontSize:"13px"}}>₹ {numeral(data.Rate).format('0,0.00')}</td>
                          <td style={{fontSize:"13px"}}>₹ {numeral((data.Rate)/(100 + data.GSTPer)*100).format('0,0.00')}</td>
                          <td style={{fontSize:"13px"}}>{parseFloat(data.Order_Qty)}</td>

                          <td style={{fontSize:"13px"}}>{data.GSTPer}</td>
                          <td style={{fontSize:"13px"}}>{numeral((data.Order_Qty * (data.Rate)/(100 + data.GSTPer)*100) * (data.GSTPer)/100).format('0,0.00') }</td>
                          <td style={{fontSize:"13px"}}>{numeral(numeral(((data.Rate)/(100 + data.GSTPer)*100)).format('0,0.00') * parseFloat(data.Order_Qty)).format('0,0.00')}</td>
                      
               
                                </tr>
                          ))}
                             {/* <tr>
         
         <th scope="col" style={{fontSize:"11px"}}></th>
                       <th scope="col" style={{fontSize:"11px"}}></th>
                       <th scope="col" style={{fontSize:"11px"}}></th>
                       <th scope="col" style={{fontSize:"11px"}}></th>
         <th scope="col" style={{fontSize:"11px"}}>{parseFloat(localStorage.getItem('TotalQty1'))}</th>
                       <th scope="col" style={{fontSize:"11px"}}>₹{numeral((localStorage.getItem('totalsalesrate'))).format('0,0.00')}</th>
                       <th scope="col" style={{fontSize:"11px"}}>₹{numeral(localStorage.getItem('totalsalesgstamt')).format('0,0.00')}</th>
                       <th scope="col" style={{fontSize:"11px"}}>₹ {numeral(parseFloat(localStorage.getItem('totalsalesrate'))+parseFloat(localStorage.getItem('totalsalesgstamt'))).format('0,0.00') }</th>
         </tr> */}
                            {/* <tr>
                              <th colSpan="4" className="text-end">Sub Total</th>
                              <td className="text-end"></td>
                            </tr>
                            <tr>
                              <th colSpan="4" className="border-0 text-end">
                                Discount :</th>
                              <td className="border-0 text-end">- </td>
                            </tr>
                            <tr>
                              <th colSpan="4" className="border-0 text-end">
                                Shipping Charge :</th>
                              <td className="border-0 text-end"></td>
                            </tr>
                            <tr>
                              <th colSpan="4" className="border-0 text-end">
                                Tax</th>
                              <td className="border-0 text-end"></td>
                            </tr>
                            <tr>
                              <th colSpan="4" className="border-0 text-end">Total</th>
                              <td className="border-0 text-end"><h4 className="m-0"></h4></td>
                            </tr> */}
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
 <tr>
                            <td></td>
                            <td style={{fontSize:"12px"}} > </td>
                                 <td style={{fontSize:"12px"}} > </td>
                                        <td style={{fontSize:"12px"}}> </td>
                                        <td style={{fontSize:"12px"}}></td>
                                        <td style={{fontSize:"12px"}}></td>
                                        <td style={{fontSize:"12px"}}></td>
                                     
                                        <td style={{fontSize:"14px",fontWeight:'bold'}}>Total Qty </td>
                                        <td style={{fontSize:"13px"}}>{parseFloat(localStorage.getItem('TotalQty1'))}</td>
                                       
                            </tr>
                            <tr>
                            <td></td>
                            <td style={{fontSize:"12px"}} > </td>
                                 <td style={{fontSize:"12px"}} > </td>
                                        <td style={{fontSize:"12px"}}> </td>
                                        <td style={{fontSize:"12px"}}></td>
                                        <td style={{fontSize:"12px"}}></td>
                                        <td style={{fontSize:"12px"}}></td>
                                     
                                        <td style={{fontSize:"14px",fontWeight:'bold'}}>Gross Amount</td>
                                        <td style={{fontSize:"13px"}}>₹ {numeral((localStorage.getItem('totalsalesrate'))).format('0,0.00')}</td>
                                        <td style={{fontSize:"12px"}}></td>
                                     <td style={{fontSize:"12px"}}></td>
                                     <td style={{fontSize:"12px"}}></td>
                                     <td style={{fontSize:"12px"}}> </td>
                                     <td style={{fontSize:"12px"}}></td>
                             
                            </tr>
                            <tr>
                            <td></td>
                            <td style={{fontSize:"12px"}} > </td>
                                 <td style={{fontSize:"12px"}} > </td>
                                        <td style={{fontSize:"12px"}}> </td>
                                        <td style={{fontSize:"12px"}}></td>
                                        <td style={{fontSize:"12px"}}></td>
                                        <td style={{fontSize:"12px"}}></td>
                                     
                                        <td style={{fontSize:"14px",fontWeight:'bold'}}>Gst  Amount</td>
                                        <td style={{fontSize:"13px"}}>₹ {numeral(localStorage.getItem('totalsalesgstamt')).format('0,0.00')}</td>
                                        <td style={{fontSize:"12px"}}></td>
                                     <td style={{fontSize:"12px"}}></td>
                                     <td style={{fontSize:"12px"}}></td>
                                     <td style={{fontSize:"12px"}}> </td>
                                     <td style={{fontSize:"12px"}}></td>
                             
                            </tr>
                            <tr>
                            <td></td>
                            <td style={{fontSize:"12px"}} > </td>
                                 <td style={{fontSize:"12px"}} > </td>
                                        <td style={{fontSize:"12px"}}> </td>
                                        <td style={{fontSize:"12px"}}></td>
                                        <td style={{fontSize:"12px"}}></td>
                                        <td style={{fontSize:"12px"}}></td>
                                     
                                        <td style={{fontSize:"14px",fontWeight:'bold'}}>Total </td>
                                        <td style={{fontSize:"13px"}}>₹ {numeral(parseFloat(localStorage.getItem('totalsalesrate'))+parseFloat(localStorage.getItem('totalsalesgstamt'))).format('0,0.00') }</td>
                                        <td style={{fontSize:"12px"}}></td>
                                     <td style={{fontSize:"12px"}}></td>
                                     <td style={{fontSize:"12px"}}></td>
                                     <td style={{fontSize:"12px"}}> </td>
                                     <td style={{fontSize:"12px"}}></td>
                             
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                      <div className="d-print-none mt-4">
                        <div className="float-end">
                          <Link to="#" onClick={viewpage} className="btn btn-success waves-effect waves-light me-1"><i className="fa fa-print"></i></Link>{" "}
                          {/* <Link to="#" className="btn btn-primary w-md waves-effect waves-light">Send</Link> */}
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
      
        </Container>
      </div>
      <Dialog  onClose={Closepopup1}   aria-labelledby="simple-dialog-title" open={open1}>
      <iframe src={axios.baseURL+`GetSalesOrder`} style={{width:'500px', height:'500px'  }} ></iframe>
      {/* <object data={axios.baseURL+`Getpurchaseorder`}   style={{width:'500px', height:'500px'  }}  /> */}
      {/* <Document file={axios.baseURL+`Getpurchaseorder`} >
 
      </Document> */}
    {dailoa1 ? (
      <Backdrop  open={dailoa1} className={classes.backdrop} >
      <Spinner name="ball-spin-fade-loader"  color='#fafafa' />

     </Backdrop>
      ): null}
    </Dialog>
    </React.Fragment>
  );
};

InvoiceDetail.propTypes = {
  invoiceDetail: PropTypes.object,
  onGetInvoiceDetail: PropTypes.func,
};

const mapStateToProps = ({ invoices }) => ({
  invoiceDetail: invoices.invoiceDetail,
});

const mapDispatchToProps = dispatch => ({
  onGetInvoiceDetail: id => dispatch(getInvoiceDetail(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(InvoiceDetail));
